import moment from "moment-hijri";

export const currentMonth = moment().iMonth() + 1;

// // export default function ramadan() {
// //     return (
// //         currentMonth
// //     )
// // }
